const OPERATIONS = [
  {
    title: "Addition",
    sign: "+",
  },
  {
    title: "Soustraction",
    sign: "-",
  },
  {
    title: "Multiplication",
    sign: "×",
  },
  {
    title: "Division",
    sign: "÷",
  },
];

export default OPERATIONS;
